import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {EmployeesTableLazy} from "@containers/employee/employeesTable/EmployeesTable.lazy";

const EmployeesListPage = () => {
	return (
		<PageLayout>
			<Suspense
				fallback={<SpinnerCustom/>}
			>
				<EmployeesTableLazy/>
			</Suspense>
		</PageLayout>
	)
};

export default EmployeesListPage;